// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-main {\n  color: var(--main-color);\n}\n.c-sidebar-text-color {\n  color: var(--sidebar-text-color);\n}\n.cur-p {\n  cursor: pointer;\n}\n.w100 {\n  width: 100%;\n}\n\n.secondary-font {\n  font-family: var(--secondary-font);\n}\n\n.sticky {\n  position: sticky;\n}\n\n.fz-40 {\n  font-size: 2.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
